import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { InvoiceCommand, InvoiceStatus } from "./invoice.model";
import { DeliveredInvoiceTypeEnum } from "./delivered-status.enum";

export class DeliveredListInvoice extends EntityBase {
  public Id: number;
  public NumberingInDate?: number;
  public SaleMethodBranchTitle: string;
  public Description: string;
  public CreateDateTime?: Date;
  public SaleMethodBranchId?: number;
  public SaleMethodNatureCode?: number;
  public Items: DeliveredListInvoiceItem[];
  public Quantity?: number;
  public InvoiceCommand: InvoiceCommand;
  public Status: InvoiceStatus;
  public DeliveredInvoiceType: number;
  public FactorStringTime: string;
  public DeliverStringTime: string;
  public CustomerDisplayName: string;
  public SalonTitle: string;
  public SalonId?: number;
  public HasExpired:boolean;
}

export class DeliveredListInvoiceItem extends EntityBase {
  public ItemTitle: string;
  public Quantity?: number;
  public ItemId?: number;
  public CategoryId?: number;
  public Checked?: boolean;
  public CookingTime: number;
}

export class InvoiceDelivered extends EntityBase {
  public InvoiceId?: number;
  public DeliveredTime: string;
  public SaleMethodNatureCode?: number;
  public DeliveredInvoiceType: number;
  public InvoiceDeliveredItemList: InvoiceDeliveredItem[];
  /**
   *
   */
  constructor() {
    super();
    this.InvoiceId = null;
    this.DeliveredTime = null;
    this.DeliveredInvoiceType = null;
    this.InvoiceDeliveredItemList = [];
  }
}

export class InvoiceDeliveredItem extends EntityBase {
  public InvoiceItemId?: number;
  public InvoiceDeliveredId?: number;
  /**
   *
   */
  constructor() {
    super();
    this.InvoiceItemId = 0;
    this.InvoiceDeliveredId = 0;
  }
}
